export default __webpack_public_path__ + "static/media/nodata.e7d72fb9.png";